//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const FixateOnLock: FeatureFlag = {"Id":"FixateOnLock","Label":"[10.20]Fixate submissions while locked","Impact":"Fixates/unfixates calculations based on lock presence. Often used with PaymentLocks so payment locks preserve calculation consistency while form is locked.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
